// Swiper core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Scrollbar, Grid } from 'swiper/modules';
// Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/grid';
export var NewsController = {
    init: function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                _this.initNewsPagination();
                resolve();
            }
            catch (error) {
                reject(error);
            }
        });
    },
    initNewsPagination: function () {
        var thumbContainer = document.querySelector('.news-list');
        if (thumbContainer) {
            new Swiper(thumbContainer, {
                modules: [Navigation, Scrollbar, Grid],
                spaceBetween: 30,
                slidesPerView: 2, // Layout: 2 columns × 2 rows
                grid: { rows: 2, fill: 'row' }, // Move 2 slides at a time
                slidesPerGroup: 2,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        grid: { rows: 1, fill: 'row' },
                        slidesPerGroup: 1,
                    },
                    640: {
                        slidesPerView: 2,
                        grid: { rows: 2, fill: 'row' },
                        slidesPerGroup: 2,
                    },
                },
            });
        }
    },
};
